export const GET_CURRENCY_DEFINITIONS = "GET_CURRENCY_DEFINITIONS"
export const GET_CURRENCY_DEFINITIONS_SUCCESS = "GET_CURRENCY_DEFINITIONS_SUCCESS"
export const GET_CURRENCY_DEFINITIONS_FAIL = "GET_CURRENCY_DEFINITIONS_FAIL"

export const GET_CURRENCY_DEFINITIONS_SYNC = "GET_CURRENCY_DEFINITIONS_SYNC"
export const GET_CURRENCY_DEFINITIONS_SYNC_SUCCESS = "GET_CURRENCY_DEFINITIONS_SYNC_SUCCESS"
export const GET_CURRENCY_DEFINITIONS_SYNC_FAIL = "GET_CURRENCY_DEFINITIONS_SYNC_FAIL"

export const ADD_CURRENCY_DEFINITION = "ADD_CURRENCY_DEFINITION"
export const ADD_CURRENCY_DEFINITION_SUCCESS = "ADD_CURRENCY_DEFINITION_SUCCESS"
export const ADD_CURRENCY_DEFINITION_FAIL = "ADD_CURRENCY_DEFINITION_FAIL"

export const UPDATE_CURRENCY_DEFINITION = "UPDATE_CURRENCY_DEFINITION"
export const UPDATE_CURRENCY_DEFINITION_SUCCESS = "UPDATE_CURRENCY_DEFINITION_SUCCESS"
export const UPDATE_CURRENCY_DEFINITION_FAIL = "UPDATE_CURRENCY_DEFINITION_FAIL"

export const DELETE_CURRENCY_DEFINITION = "DELETE_CURRENCY_DEFINITION"
export const DELETE_CURRENCY_DEFINITION_SUCCESS = "DELETE_CURRENCY_DEFINITION_SUCCESS"
export const DELETE_CURRENCY_DEFINITION_FAIL = "DELETE_CURRENCY_DEFINITION_FAIL"

export const CLIENT_API_ERROR = "CLIENT_API_ERROR"
